import { NotFound } from "@dgs/core";
import { FC } from "react";
import { Route, Routes } from "react-router";
import { AppNotificationCreatePage } from "../appNotifications/AppNotificationCreatePage";
import { AppNotificationList } from "../appNotifications/AppNotificationList";
import { AppNotificationUpdatePage } from "../appNotifications/AppNotificationUpdatePage";

export const AppNotificationPage: FC = () => {
	return (
		<Routes>
			<Route index element={<AppNotificationList />} />
			<Route path="new" element={<AppNotificationCreatePage />} />
			<Route path=":appNotificationId" element={<AppNotificationUpdatePage />} />
			<Route path="*" element={<NotFound />} />
		</Routes>
	);
};
